<script>
import { inject } from 'vue'
import { mapState, mapActions } from 'vuex'
import BaseSpinButton from './BaseSpinButton.vue'
import BasePrice from './BasePrice.vue'
import BaseClose from './BaseClose.vue'

export default {
  name: 'TheCart',

  components: {
    BaseSpinButton,
    BasePrice,
    BaseClose
  },
  
  data () {
    return {
      isCartPage: false
    }
  },

  computed: {
    ...mapState({
      cart: 'cart',
      cartIsInitialized: 'cartIsInitialized',
      isUpdating: 'cartIsUpdating'
    }),

    checkoutLabel () {
      return this.isUpdating ? 'updating' : window.theme.language.sections.cart.checkout
    },
    
    total () {
      return this.$filters.shopifyMoney(this.cart.total_price)
    }
  },

  created () {
    this.initCart()
  },

  methods: {
    ...mapActions({
      updateCart: 'updateCart',
      changeCart: 'changeCart'
    }),

    initCart () {
      this.isCartPage = document.querySelector('.template-cart') !== null
      this.updateCart()
    },

    handleQuantityChange (key, quantity) {
      this.changeCart({ key, quantity }).then(() => {
        this.$refs[`spinbutton${key}`][0].checkForMaximum()
      })
    }
  }
}
</script>

<template>
  <div
    v-if="cartIsInitialized"
    id="Cart"
    class="cart"
  >
    <h1
      v-if="isCartPage"
      class="cart__title t-heading"
    >
      {{ window.theme.language.sections.cart.title }}
    </h1>

    <h2
      v-else
      class="cart__title t-heading"
    >
      <a href="/cart">{{ window.theme.language.sections.cart.title }}</a>
    </h2>
    
    <form
      v-if="cart.item_count > 0"
      action="/cart"
      method="post"
      class="cart__form"
      novalidate
    >
      <ul class="cart__list">
        <li
          v-for="(item, index) in cart.items"
          :key="item.id"
          class="cart__list-item"
        >
          <div class="cart__item-image-container">
            <a
              :href="item.url"
              class="cart__item-image"
            >
              <img
                :src="$filters.shopifyImgUrl(item.image, 200)"
                :alt="item.title"
                class="lazyload"
              >
            </a>
          </div>

          <div class="cart__item-details">
            <div class="cart__item-text">
              <component
                :is="isCartPage ? 'h2' : 'h3'"
                class="cart__item-title t-title"
              >
                <a :href="item.url">{{ item.title }}</a>
              </component>
              
              <div class="cart__item-price">
                <BasePrice>
                  {{ $filters.shopifyMoney(item.price) }}
                </BasePrice>
              </div>
            </div>

            <div class="cart__item-form-controls">
              <BaseSpinButton
                :id="`updates_${item.key}`"
                :ref="`spinbutton${item.key}`"
                :label="window.theme.language.products.product.quantity.label"
                :name="`items[${index}]quantity`"
                :min="0"
                :max="null"
                :default-value="item.quantity"
                :is-disabled="item.product_type === 'pack'"
                @quantity="(quantity) => handleQuantityChange(item.key, quantity)"
              />

              <BaseClose
                :href="`/cart/change?line=${index + 1}&amp;quantity=0`"
                :label="window.theme.language.sections.cart.removeTitle"
                @click="changeCart({ key: item.key, quantity: 0 })"
              />
            </div>
          </div>
        </li>
      </ul>

      <div class="cart__footer">
        <div class="cart__footer-buttons">
          <button
            type="submit"
            name="checkout"
            class="cart__checkout cta t-cta"
            :disabled="isUpdating"
          >
            <span class="cart__subtotal-price"><span class="visually-hidden">{{ window.theme.language.sections.cart.subtotal }}: </span>{{ $filters.shopifyMoney(cart.total_price) }}</span>
            <span>{{ checkoutLabel }}</span>
          </button>
        </div>
      </div>
    </form>

    <p
      v-else
      class="cart__empty-messaging"
    >
      {{ window.theme.language.sections.cart.empty }}
    </p>
  </div>
</template>
